<template>
  <v-card-text>
      <div>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-text-field
            v-model="mobile"
            label="Mobile Number*"
            light
            required
            outlined
          />

          <v-text-field
            v-model="email"
            label="Email Address*"
            light
            required
            outlined
          />

          <v-text-field
            v-model="companyName"
            label="Company Name*"
            light
            required
            outlined
          />

          <v-text-field
            v-model="firstName"
            label="First Name*"
            light
            required
            outlined
          />

          <v-text-field
            v-model="lastName"
            light
            label="Last Name*"
            required
            outlined
          />
        </v-form>
      </div>
      <v-card-actions>
        <v-btn color="orange darken-3" x-large block
          :disabled="isSubmitDisabled"
          class="rounded-xl"
          dark
          @click.prevent="onFormSubmit()"
          >
           Confirm
        </v-btn>
      </v-card-actions>
  </v-card-text>
</template>

<script>
import axios from '@/app-axios'
import moment from 'moment'
import constants from '@/constants'

export default {
  name: 'CheckinConfirm',

  data: () => ({
    valid: false,
    companyName: '',
    firstName: '',
    lastName: '',
    email: '',
    mobile: ''
  }),

  computed: {
    hasEmptyFields () {
      return this.mobile.trim() === '' ||
         this.firstName.trim() === '' ||
         this.lastName.trim() === ''
    },
    isSubmitDisabled () {
      return this.hasEmptyFields
    }
  },

  mounted () {
    // if user exist, autofill
    const user = this.$store.getters['swiftuser/getUser']
    if (Object.keys(user).length > 0) {
      this.firstName = user.first_name
      this.lastName = user.last_name
      this.email = user.email
      this.mobile = user.mobile

      return
    }
    this.mobile = this.$store.getters['swiftuser/getMobile']
  },

  methods: {
    formatExtraDetails () {
      var formatted = []

      formatted.push({
        answers: this.$store.getters['questions/getUserSelectedAnswers']
      })

      return formatted
    },

    onFormSubmit () {
      this.formatExtraDetails()
      var config = {
        headers: {
          'x-organization-id': this.$store.getters['swiftuser/getOrganizationId'],
          'x-digi-board-id': this.$store.getters['swiftuser/getDigiBoardId']
        }
      }
      // if user not exist, create one
      const user = this.$store.getters['swiftuser/getUser']
      if (Object.keys(user).length > 0) {
        config.headers['x-swift-user-id'] = user.id
        this.checkInUser(config)
        return
      }
      axios.post('api/swift-checkin/user', {
        first_name: this.firstName,
        last_name: this.lastName,
        mobile: this.mobile,
        email: this.email,
        company: this.companyName
      }, config).then(response => {
        config.headers['x-swift-user-id'] = response.data.id
        this.$store.dispatch('swiftuser/onAddUser', response.data)
        this.checkInUser(config)
      }).catch(error => {
        this.$store.dispatch('alert/onAlert', {
          message: error.response.data.errors[0],
          type: constants.ALERT_TYPE_ERROR
        })
      })
    },

    checkInUser (config) {
      axios.post('api/swift-checkin/checkin', {
        check_in_time: moment.utc().format(),
        type: this.$store.getters['decision/getCustomerType'],
        extra_details: this.formatExtraDetails(),
        reporting_staff: 'Simone Mary',
        department: 'Logistics'
      }, config).then(response => {
        this.$emit('stepSuccess')
      }).catch(error => {
        this.$store.dispatch('alert/onAlert', {
          message: error.response.data.errors[0],
          type: constants.ALERT_TYPE_ERROR
        })
      })
    }
  }
}
</script>
